import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './session.types';
import * as constants from './session.constants';

export const sessionReducer = generateResourceReducer<types.ISession>({
  STORE: constants.STORE_SESSION,
  CLEAR: constants.CLEAR_SESSION,
});
